(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-reviews')) {
    customElements.define(
      'custom-reviews',
      class CustomReviews extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-custom-reviews-track]');
          this.prev = this.querySelector('[data-custom-reviews-prev]');
          this.next = this.querySelector('[data-custom-reviews-next]');
          if (!this.track || !this.prev || !this.next) return;

          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.onScroll = () => this.update();

          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.prev.removeEventListener('click', this.onPrev);
          this.next.removeEventListener('click', this.onNext);
          this.track.removeEventListener('scroll', this.onScroll);
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        step() {
          const card = this.track.firstElementChild;
          if (!card) return 0;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        }

        go(direction) {
          this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = this.track.scrollLeft <= 1;
          this.next.disabled = this.track.scrollLeft >= max - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
